import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Lightbulb,
  BarChart2,
  Settings,
  HelpCircle,
  FileText,
  Calendar
} from 'lucide-react';

const menuItems = [
  { icon: Home, label: 'Início', path: '/dashboard' },
  { icon: Lightbulb, label: 'Ideias', path: '/dashboard/ideias' },
  { icon: Calendar, label: 'Calendário', path: '/dashboard/calendario' },
  { icon: BarChart2, label: 'Análises', path: '/dashboard/analises' },
  { icon: FileText, label: 'Planos', path: '/dashboard/planos' },
  { icon: Settings, label: 'Config.', path: '/dashboard/configuracoes' },
  { icon: HelpCircle, label: 'Ajuda', path: '/dashboard/ajuda' }
];

export default function MobileNavigation() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex px-2 py-2 min-w-max">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center justify-center py-1 px-4 rounded-lg ${
                  isActive
                    ? 'text-indigo-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs mt-1">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}